import NoContentTab from './NoContentTab';

export default NoContentTab;
